import TextField from '@gogame/ui/TextField';

export const CommentField = ({
  value,
  error,
  onFocus,
  onChange,
  label = 'Comment',
  autoFocus = false,
}) => {
  return (
    <TextField
      label={label}
      multiline
      autoFocus={autoFocus}
      fullWidth={true}
      onFocus={onFocus}
      value={value}
      onChange={onChange}
      error={error}
    />
  );
};

export default CommentField;
